import React, {Component} from 'react';
import {MODES} from '../Constants';
import './IntroSplash.css';

class IntroSplash extends Component {

  onClose = () => {
    this.props.onClose();
  };

  onClickWildfire = () => {
    this.onClose();
    this.props.setMode(MODES.WILDFIRE);
  };

  onClickPlannedBurns = () => {
    // Need to close before setting mode to make the incidentMiddleware work right.
    this.onClose();
    this.props.setMode(MODES.PLANNED_BURNS);
  };

  onClickHindsight = () => {
    // this.onClose();
    // this.props.setMode(MODES.HINDSIGHT);
  };

  eatClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  render() {
    return (
      <div className="introSplashPanel" onClick={this.eatClick}>
        <div className="introSplashPanel__content">
          <div className="introSplashPanel__top">
            <div className="introSplashPanel__logo"/>
            <div className="choose">
              Choose your context:
            </div>
          </div>
          <div className="introSplashPanel__middle">
            <div className="introSplash__choice introSplash__wildfire" onClick={this.onClickWildfire}>
              <div>Bushfire</div>
              <div className="introSplash__image"/>
            </div>
            <div className="introSplash__choice introSplash__planned" onClick={this.onClickPlannedBurns}>
              <div>Planned Burning</div>
              <div className="introSplash__image"/>
            </div>
            <div className="introSplash__choice introSplash__hindsight" onClick={this.onClickHindsight}>
              <div>Hindsight</div>
              <div className="introSplash__image"/>
            </div>
          </div>
          <div className="introSplashPanel__bottom">
            <div className="rule"/>
            <div className="disclaimer">
              Disclaimer: This application displays forecast data generated from Victorian Government and Bureau of
              Meteorology data. This material may be of assistance to you but the State of Victoria does not guarantee
              that the application is without flaw of any kind or is wholly appropriate for your particular purposes and
              therefore disclaims all liability for error, loss or damage which may arise from reliance upon it. All
              persons accessing this information should make appropriate enquiries to assess the currency of the data.
            </div>
            <div className="notes">
              Also note that:
              <ul>
                <li>
                  <span style={{ color: 'red', fontWeight: 'bold' }}>NEW: </span>
                  The AFDRS went live on 1 September 2022. The AFDRS outputs &quot;Fire Behaviour Index&quot; and
                  &quot;Fire Danger Rating&quot; have been integrated into Foresight.
                </li>
                <li>
                  <span style={{ color: 'red', fontWeight: 'bold' }}>NEW: </span>
                  FFDI and GFDI are no longer produced by BOM and are now produced by Victorian fire agencies.
                </li>
                <li>
                  Foresight includes data that requires training and experience to properly interpret. You
                  should request assistance from a fire behaviour analyst or BOM meteorologist if you are unsure.
                </li>
                <li>
                  The date and time that the visible indicator layer was last updated is shown in both the box in the
                  top
                  left-hand corner of the map window and at the bottom of the legend.
                </li>
                <li>
                  Foresight does not replace the need for Incident Weather Forecasts (IWF). IWFs are a tailored
                  meteorological forecast for an incident area that will be based on more information than that which is
                  available within Foresight.
                </li>
                <li>
                  Foresight displays the most recent available forecast data. Weather observations are only available
                  within Foresight for specific weather station points and not as indicator layers across the state.
                  Data
                  displayed for time steps which are in the past use the last forecast available for that time step and
                  has not been updated or verified based on weather observations.
                </li>
                <li>
                  Near real-time incident information is best obtained from other spatial sources such as eMap and EM
                  COP.
                </li>
                <li>
                  Most of the datasets within Foresight were created using coarse (~3km resolution) data inputs. You
                  should exercise caution when interpreting the data within Foresight at a fine scale.
                </li>
                <li>
                  For more information about Foresight and the data available within it please read the Foresight user
                  guide <a href="http://foresight.help.ffm.vic.gov.au">http://foresight.help.ffm.vic.gov.au</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IntroSplash;



// WEBPACK FOOTER //
// ./src/components/IntroSplash.js